<script>
import { useAlert } from 'dashboard/composables';
import DynamicList from './DynamicList.vue';
import UploadFileModal from './UploadFileModal.vue';
import CreateCondoModal from './CreateCondoModal.vue';
import EditorModal from './EditorModal.vue';
import PDFViewer from './PDFViewer.vue';
import ResidentList from './ResidentList.vue';
import { mapActions, mapState } from 'vuex';
import axios from 'axios'

export default{
  name: 'CondoDetails',
  components: {
    DynamicList,
    UploadFileModal,
    CreateCondoModal,
    EditorModal,
    PDFViewer,
    ResidentList
  },
  data(){
    return{
      condoId: this.$route.params.condoId,
      activeIndex: 0,
      activeList: [],
      editObj: null,
      editItem: null,

      isShowUploadModal: false,
      isShowEditModal: false,
      isShowEditor: false,
      isShowPDFViewer: false,
      
      isCondoLoading: false,
      isDocumentsLoading: false,
      isDocumentError: false,
      isResidentLoading: false,
      isResidentError: false,

      currentFetchRequest: null,
      pdf: null,
    }
  },
  watch: {
    activeList(val){
      console.log('activeList', val)
      console.log('tabs', this.tabs[this.activeIndex].label)
    }
  },
  computed: {
    ...mapState('condoMngt', ['condoList', 'condoDetails', 'noticeList', 'momList', 'houseRuleList', 'residentList', 'mainList']),
    tabs(){
      return [
        { label: 'Notice', value: 'notice', list: this.mainList },
        { label: 'MOM', value: 'meeting_minutes', list: this.mainList },
        { label: 'House Rules', value: 'house_rules', list: this.mainList },
        { label: 'Resident Profile', value: 'resident_profile', list: this.residentList }
      ]
    },
  },
  methods: {
    ...mapActions('condoMngt', ['fetchCondo', 'fetchDocuments']),
    async refreshCondo(){
      this.isCondoLoading = true;
      try{
        await this.fetchCondo(this.condoId)
      }catch(err){
        if (Array.isArray(err)) {
          useAlert(err.join('\n'))
        } else {
          useAlert(`Failed to fetch condo`)
          console.error(err);
        }
        this.isDocumentError = true
      }finally{
        this.isCondoLoading = false;
      }
    },
    async refreshResidentList(){
      try{
        this.isResidentLoading = true;
        console.log('Refreshing resident')
      }catch(err){
        if (Array.isArray(err)) {
          useAlert(err.join('\n'))
        } else {
          useAlert(`Failed to fetch resident list`)
          console.error(err);
        }
        this.isResidentError = true
      }finally{
        this.isResidentLoading = false;
      }
    },
    async refreshDocuments() {
      // Cancel any pending request
      if (this.currentFetchRequest) {
        this.currentFetchRequest.cancel()
      }
      
      this.isDocumentsLoading = true
      this.isDocumentError = false
      
      try {
        this.currentFetchRequest = axios.CancelToken.source()
        const results = await this.fetchDocuments({
          condoId: this.condoId,
          documentType: this.tabs[this.activeIndex].value,
          page: 1,
          pageSize: 10,
          cancelToken: this.currentFetchRequest.token
        })
        this.activeList = results
      } catch(err) {
        this.isDocumentError = true
        if (Array.isArray(err)) {
          useAlert(err.join('\n'))
        } else {
          useAlert('Failed to fetch documents')
          console.error(err)
        }
      } finally {
        this.isDocumentsLoading = false
        this.currentFetchRequest = null
      }
    },
    handleUpload(){
      this.isShowUploadModal = true
    },
    async onTabChange(index) {
      this.activeIndex = index
      this.activeList = []
      
      try {
        if(this.tabs[index].value === 'resident_profile') {
          this.activeList = this.residentList
        } else {
          await this.refreshDocuments()
        }
      } catch(err) {
        console.error('Failed to update tab content:', err)
      }
    },
    handleCloseEdit(){
      this.editObj = null;
      this.isShowEditModal = false;
    },
    handleEdit(){
      this.editObj = this.condoDetails;
      this.isShowEditModal = true;
    },
    handleItemClick(item){
      this.editItem = item;
      if(this.tabs[this.activeIndex].value !== 'house_rules'){
        this.isShowEditor = true;
      }else{
        this.openPdfFile(item.presigned_file_url)
        // this.pdf = item.presigned_file_url;
        // this.isShowPDFViewer = true;
      }
    },
    openPdfFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleCloseEditor(){
      this.editItem = null;
      this.isShowEditor = false;
    },
    handleClosePDFViewer(){
      this.editItem = null;
      this.pdf = null;
      this.isShowPDFViewer = false;
    }
  },
  async mounted() {
    try {
      await this.fetchCondo(this.condoId)
      await this.refreshDocuments()
    } catch(err) {
      console.error('Error during component mount:', err)
    }
  },
  beforeUnmount() {
    if (this.currentFetchRequest) {
      this.currentFetchRequest.cancel()
    }
    this.handleClosePDFViewer();
  }
}
</script>

<template>
  <div class="p-2 md:p-8 flex flex-1 h-full gap-3 flex-col m-0 bg-slate-25 dark:bg-slate-900 overflow-auto">
    <!-- Modals -->
    <UploadFileModal v-if="isShowUploadModal" @close="isShowUploadModal = false" @refresh="refreshDocuments" />
    <CreateCondoModal v-if="isShowEditModal" :is-edit-mode="isShowEditModal" :edit-obj="editObj" @close="handleCloseEdit" @refresh="refreshCondo" />
    <EditorModal v-if="isShowEditor" @close="handleCloseEditor" :item="editItem" @refresh="refreshDocuments" />
    <PDFViewer v-if="isShowPDFViewer" :pdfUrl="pdf" @close="handleClosePDFViewer" />

    <!-- Header -->
    <div class="flex w-full justify-between mb-4">
      <div class="flex gap-2 items-center">
        <woot-button variant="clear" icon="chevron-left" @click="$router.back()"/>
        <p class="text-2xl font-bold mb-0">Condo Details</p>
      </div>
      <woot-button icon="add" @click="handleUpload">Upload Files</woot-button>
    </div>

    <!-- Condo Details -->
    <div v-if="isCondoLoading" class="w-full flex-wrap p-2 rounded flex gap-2 group relative bg-slate-100 dark:bg-slate-800">
      <div class="h-60 w-60 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"></div>
      <div class="flex-1">
        <div class="mb-2">
          <div class="h-4 w-24 bg-slate-200 dark:bg-slate-700 rounded mb-2 animate-pulse"></div>
          <div class="h-4 w-48 bg-slate-200 dark:bg-slate-700 rounded animate-pulse"></div>
        </div>
        <div class="mb-2">
          <div class="h-4 w-24 bg-slate-200 dark:bg-slate-700 rounded mb-2 animate-pulse"></div>
          <div class="h-4 w-72 bg-slate-200 dark:bg-slate-700 rounded animate-pulse"></div>
        </div>
        <div class="mb-2">
          <div class="h-4 w-24 bg-slate-200 dark:bg-slate-700 rounded mb-2 animate-pulse"></div>
          <div class="h-4 w-96 bg-slate-200 dark:bg-slate-700 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
    <div v-else-if="condoDetails" class="w-full flex-wrap p-2 rounded flex gap-2 group relative bg-slate-100 dark:bg-slate-800">
      <div v-if="condoDetails.presigned_image_url" class="overflow-hidden h-60 w-60 rounded flex items-center justify-center bg-slate-200 dark:bg-slate-700 text-slate-500 dark:text-slate-300">
        <img 
          :src="condoDetails.presigned_image_url" 
          :alt="condoDetails.condo_name" 
          class="w-full h-full object-cover"
        />
      </div>
      <div v-else class="h-60 w-60 rounded flex items-center justify-center bg-slate-200 dark:bg-slate-700 text-slate-500 dark:text-slate-300">
        <fluent-icon icon="condo" class="h-14 w-14" />
      </div>
      <div>
        <div class="mb-2">
          <p class="font-bold mb-0 text-slate-800 dark:text-slate-100">Condo Name</p>
          <p class="text-slate-600 dark:text-slate-300">{{ condoDetails.condo_name }}</p>
        </div>
        <div class="mb-2">
          <p class="font-bold mb-0 text-slate-800 dark:text-slate-100">Address</p>
          <p class="text-slate-600 dark:text-slate-300">{{ condoDetails.address }}</p>
        </div>
        <div class="mb-2">
          <p class="font-bold mb-0 text-slate-800 dark:text-slate-100">Description</p>
          <p class="text-slate-600 dark:text-slate-300">{{ condoDetails.description }}</p>
        </div>
      </div>

      <div class="p-2 absolute top-0 right-0 flex justify-end opacity-0 group-hover:opacity-100 transition-opacity">
        <woot-button
          @click.stop="handleEdit"
          variant="clear"
          icon="edit"
          size="small"
        />
      </div>
    </div>

    <!-- File list (tabs) -->
    <woot-tabs
      :index="activeIndex"
      class="-mt-px bg-white dashboard-app--tabs dark:bg-slate-900"
      @change="onTabChange"
    >
      <woot-tabs-item
        v-for="tab in tabs"
        :key="tab.label"
        :name="tab.label"
        :show-badge="false"
      />
    </woot-tabs>
    <DynamicList 
      v-if="tabs[activeIndex].label !== 'Resident Profile'" 
      :list-type="tabs[activeIndex].label" 
      :list="activeList"
      :is-loading="isDocumentsLoading"
      :is-error="isDocumentError"
      @clicked="handleItemClick"
      @refresh="refreshDocuments"
    />
    <ResidentList v-else @refresh="refreshResidentList" />
  </div>
</template>